/**
 * Input Sanitization Utilities
 */

/**
 * Sanitize email (lowercase + trim)
 */
export function sanitizeEmail(email: string): string {
  return email.toLowerCase().trim();
}

/**
 * Sanitize text (trim)
 */
export function sanitizeText(text: string): string {
  return text.trim();
}

/**
 * Sanitize name (trim + capitalize words)
 */
export function sanitizeName(name: string): string {
  return name.trim();
}







